import {
  DatabaseOutlined,
  HomeOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { buildMenuItem } from 'config/menu-item';

export const roboAdvisoryItems = [
  // Header — key = '/robo-advisory', redirects to /robo-advisory/portfolios via AppRouter
  buildMenuItem(
    'Robo Advisory',
    'robo-advisory',
    '/robo-advisory',
    <HomeOutlined />
  ),
  buildMenuItem('Portfolios', 'portfolios', '/robo-advisory/portfolios'),
  buildMenuItem(
    'Stag Portfolios',
    'stag-portfolios',
    '/robo-advisory/stag-portfolios'
  ),
  buildMenuItem(
    'Surveys',
    'surveys',
    null,
    null,
    [
      buildMenuItem(
        'Survey Reports',
        'survey-reports',
        '/robo-advisory/survey-reports'
      ),
    ],
    'group'
  ),
];

export const investmentItems = [
  buildMenuItem('Investment', 'investment', '/investment', <HomeOutlined />),
  buildMenuItem('Orders', 'orders', '/investment/orders'),
  buildMenuItem('Fund Orders', 'order', '/investment/fund-orders'),
  buildMenuItem('Stock Orders', 'stock-orders', '/investment/stock-orders'),
  buildMenuItem(
    'Balance History',
    'balance-histories',
    '/investment/stock-balance-histories'
  ),

  buildMenuItem(
    'Account',
    'account',
    null,
    null,
    [
      buildMenuItem('User Accounts', 'user', '/investment/users'),
      buildMenuItem(
        'Fund Accounts',
        'fund-accounts',
        '/investment/fund-accounts'
      ),
      buildMenuItem(
        'Stock Accounts',
        'stock-accounts',
        '/investment/stock-accounts'
      ),
      buildMenuItem(
        'Bank Accounts',
        'bank-accounts',
        '/investment/bank-accounts'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'Subscription',
    'subscription',
    null,
    null,
    [
      buildMenuItem('Plans', 'subscriptions', '/investment/subscriptions'),
      buildMenuItem(
        'IAP Notifications',
        'iap-notifications',
        '/investment/iap-notifications'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'Retail',
    'retail',
    null,
    null,
    [buildMenuItem('Programs', 'user-program', '/investment/user-programs')],
    'group'
  ),
  buildMenuItem(
    'Others',
    'others',
    null,
    null,
    [
      buildMenuItem(
        'Fund Econtracts',
        'fund-econtracts',
        '/investment/fund-econtracts'
      ),
    ],
    'group'
  ),
];

export const investcoreItems = [
  buildMenuItem('Stag Admin', 'investcore', '/admin', <SettingOutlined />),
  buildMenuItem(
    'Home Screen',
    'home-screen',
    null,
    null,
    [
      buildMenuItem('Home Widgets', 'home-widgets', '/admin/home-widgets'),
    ],
    'group'
  ),
  buildMenuItem('Investment Themes', 'investment-themes', '/admin/investment-themes'),
  buildMenuItem(
    'Address Data',
    'address-data',
    null,
    null,
    [
      buildMenuItem('Provinces', 'provinces', '/admin/provinces'),
      buildMenuItem('Districts', 'districts', '/admin/districts'),
      buildMenuItem('Wards', 'wards', '/admin/wards'),
    ],
    'group'
  ),

  buildMenuItem(
    'Monitoring',
    'monitoring',
    null,
    null,
    [
      buildMenuItem(
        'Notification Logs',
        'notification-logs',
        '/admin/notification-logs'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'Access Control',
    'access-control',
    null,
    null,
    [
      buildMenuItem(
        'Staff Accounts',
        'staff-accounts',
        '/admin/staff-accounts'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'AI Agents',
    'ai-agents',
    null,
    null,
    [
      buildMenuItem('Stag Agent', 'agent', '/agent'),
      buildMenuItem('Agent approvals', 'agent-approvals', '/agent/approvals'),
      buildMenuItem('Agent activity', 'agent-activity', '/agent/activity'),
      buildMenuItem('Ops MCP', 'ops-mcp', '/admin/ops-mcp'),
    ],
    'group'
  ),
];

export const catalogItems = [
  // Header — key = '/catalog', redirects to /catalog/banks via AppRouter
  buildMenuItem('Data Catalog', 'catalog', '/catalog', <DatabaseOutlined />),
  buildMenuItem(
    'Investment Data',
    'data',
    null,
    null,
    [
      buildMenuItem('Banks', 'bank', '/catalog/banks'),
      buildMenuItem('Fund Products', 'product-fund', '/catalog/products/funds'),
      buildMenuItem('ETF Products', 'product-etf', '/catalog/products/etfs'),
      buildMenuItem(
        'Stock Products',
        'product-stock',
        '/catalog/products/stocks'
      ),
      buildMenuItem(
        'Stock Fundamentals',
        'stock-fundamentals',
        '/catalog/stock-fundamentals'
      ),
      buildMenuItem(
        'Fund Distributors',
        'fund-distributors',
        '/catalog/fund-distributors'
      ),

      buildMenuItem('Fund Managers', 'fund-managers', '/catalog/fund-managers'),

      buildMenuItem(
        'Market Calendar',
        'market-calendar',
        '/catalog/market-calendar'
      ),

      buildMenuItem('Market Index', 'market-index', '/catalog/market-index'),

      buildMenuItem('Stock Events', 'stock-event', '/catalog/stock-events'),
    ],
    'group'
  ),
  buildMenuItem(
    'ICB Classification',
    'stock-icb',
    null,
    null,
    [
      buildMenuItem(
        'Industries',
        'icb-industries',
        '/catalog/stock-icb/industries'
      ),
      buildMenuItem(
        'SuperSectors',
        'icb-supersectors',
        '/catalog/stock-icb/supersectors'
      ),
      buildMenuItem('Sectors', 'icb-sectors', '/catalog/stock-icb/sectors'),
      buildMenuItem(
        'SubSectors',
        'icb-subsectors',
        '/catalog/stock-icb/subsectors'
      ),
    ],
    'group'
  ),
];

export const nhsvItems = [
  buildMenuItem('NHSV', 'nhsv', '/nhsv/home', <SettingOutlined />),
  buildMenuItem(
    'Accounts',
    'accounts',
    null,
    null,
    [
      buildMenuItem(
        'Lookup by ID',
        'nhsv-lookup-account',
        '/nhsv/lookup-account'
      ),
      buildMenuItem(
        'Account Detail',
        'nhsv-account-detail',
        '/nhsv/account-detail'
      ),
      buildMenuItem(
        'Order History',
        'nhsv-order-history',
        '/nhsv/order-history'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'Webhooks',
    'webhooks',
    null,
    null,
    [
      buildMenuItem(
        'Webhook Configs',
        'webhook-configs',
        '/nhsv/webhook-configs'
      ),
    ],
    'group'
  ),
];

export const wealthItems = [
  // Header — key = '/wealth', redirects to /wealth/programs via AppRouter
  buildMenuItem('Private Wealth', 'wealth', '/wealth', <HomeOutlined />),
  buildMenuItem(
    'Programs',
    'wealth-programs-group',
    null,
    null,
    [
      buildMenuItem('All Programs', 'wealth-programs', '/wealth/programs'),
    ],
    'group'
  ),
  buildMenuItem(
    'Access Control',
    'wealth-access-control',
    null,
    null,
    [
      buildMenuItem(
        'Wealth Assignments',
        'wealth-user-assignments',
        '/wealth/user-assignments'
      ),
    ],
    'group'
  ),
];

export const accountingItems = [
  // Header — key = '/accounting', redirects to /accounting/home via AppRouter
  buildMenuItem('Accounting', 'accounting', '/accounting', <HomeOutlined />),
  buildMenuItem(
    'Reconciliation',
    'accounting-reconciliation',
    null,
    null,
    [
      buildMenuItem(
        'Fund Reconciliation',
        'accounting-fund-reconciliation',
        '/accounting/fund-order-reconciliation'
      ),
      buildMenuItem(
        'Stock Reconciliation',
        'accounting-stock-reconciliation',
        '/accounting/stock-order-reconciliation'
      ),
    ],
    'group'
  ),
];

export const futureflexItems = [
  // Header — key = '/futureflex', redirects to /futureflex/home via AppRouter
  buildMenuItem('FutureFlex', 'futureflex', '/futureflex', <HomeOutlined />),
  buildMenuItem(
    'Programs',
    'futureflex-programs',
    null,
    null,
    [
      buildMenuItem(
        'Employee Programs',
        'employee-program',
        '/futureflex/employee-programs'
      ),
      buildMenuItem('Orders', 'program-orders', '/futureflex/program-orders'),
    ],
    'group'
  ),
  buildMenuItem(
    'Organizations',
    'futureflex-organizations',
    null,
    null,
    [
      buildMenuItem('Companies', 'company', '/futureflex/companies'),
      buildMenuItem('Employees', 'employees', '/futureflex/employees'),
      buildMenuItem('HR Admin', 'staffs', '/futureflex/staffs'),
    ],
    'group'
  ),
];

// The agent app's sidebar is the chat thread list (apps/agent/components/ThreadSidebar).
export const agentItems = [];

export const getItems = (appKey: string) => {
  if (appKey === 'robo-advisory') {
    return roboAdvisoryItems;
  }
  if (appKey === 'investment') {
    return investmentItems;
  }
  if (appKey === 'admin') {
    return investcoreItems;
  }
  if (appKey === 'catalog') {
    return catalogItems;
  }
  if (appKey === 'nhsv') {
    return nhsvItems;
  }
  if (appKey === 'wealth') {
    return wealthItems;
  }
  if (appKey === 'accounting') {
    return accountingItems;
  }
  if (appKey === 'futureflex') {
    return futureflexItems;
  }
  if (appKey === 'agent') {
    return agentItems;
  }

  return [buildMenuItem('Stag Admin', 'home', '/home')];
};
